"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TemplateTag = exports.TemplateMentionReplacements = exports.EmailTemplateMentionSuggestions = exports.SMSTemplateMentionSuggestions = exports.EBoksTemplateMentionSuggestions = exports.LetterTemplateMentionSuggestions = exports.TemplateMentionSuggestions = exports.TemplateMention = exports.TemplateThemePaths = exports.TemplateType = exports.TemplateState = exports.TemplateGroupStates = void 0;
var TemplateGroupStates;
(function (TemplateGroupStates) {
    TemplateGroupStates["PUBLISHED_WIP"] = "PUBLISHED WORK IN PROGRESS";
    TemplateGroupStates["PUBLISHED"] = "PUBLISHED";
    TemplateGroupStates["NEVER_PUBLISHED"] = "NEVER PUBLISHED";
    TemplateGroupStates["WIP"] = "WORK IN PROGRESS";
})(TemplateGroupStates || (exports.TemplateGroupStates = TemplateGroupStates = {}));
var TemplateState;
(function (TemplateState) {
    TemplateState["PUBLISHED"] = "PUBLISHED";
    TemplateState["DRAFT"] = "DRAFT";
    TemplateState["VERSION"] = "VERSION";
})(TemplateState || (exports.TemplateState = TemplateState = {}));
var TemplateType;
(function (TemplateType) {
    TemplateType["EMAIL"] = "email";
    TemplateType["LETTER"] = "letter";
    TemplateType["SMS"] = "sms";
    TemplateType["AUTOCALL"] = "autocall";
    TemplateType["EBOKS"] = "eboks";
})(TemplateType || (exports.TemplateType = TemplateType = {}));
var TemplateThemePaths;
(function (TemplateThemePaths) {
    TemplateThemePaths["PLAIN"] = "defaults/plain/default";
    TemplateThemePaths["PLAIN_WITH_LOGO"] = "defaults/plain/default-with-logo";
    TemplateThemePaths["PLAIN_RKI"] = "defaults/plain/rki";
    TemplateThemePaths["PLAIN_RKI_DEBITOR_REGISTRET"] = "defaults/plain/rki-debitor-registret";
    TemplateThemePaths["PLAIN_WITH_HEADER"] = "defaults/plain/default-with-header";
    TemplateThemePaths["PLAIN_WITH_HEADER_CREDITORS"] = "defaults/plain/default-with-header-creditors";
})(TemplateThemePaths || (exports.TemplateThemePaths = TemplateThemePaths = {}));
var TemplateMention;
(function (TemplateMention) {
    TemplateMention["GENERIC_EMAIL_SUBJECT"] = "{{genericEmailSubject}}";
    TemplateMention["DEPOSIT"] = "{{formattedFields.financials.deposit}}";
    TemplateMention["FINANCIALS_INTERESTS"] = "{{formattedFields.financials.interests}}";
    TemplateMention["FINANCIALS_DEBT_COLLECTION_COSTS"] = "{{formattedFields.financials.debtCollectionCosts}}";
    TemplateMention["FINANCIALS_PRICIPAL"] = "{{formattedFields.financials.principal}}";
    TemplateMention["FINANCIALS_ADMINISTRATION_COSTS"] = "{{formattedFields.financials.administrationCosts}}";
    TemplateMention["FINANCIALS_COMPENSATION_FEES"] = "{{formattedFields.financials.compensationFees}}";
    TemplateMention["FINANCIALS_DEBT_COLLECTION_FEES"] = "{{formattedFields.financials.debtCollectionFees}}";
    TemplateMention["REMINDER_FEES"] = "{{formattedFields.financials.reminderFees}}";
    TemplateMention["TOTAL_DEBT"] = "{{formattedFields.financials.totalDebt}}";
    TemplateMention["OVERPAYMENT"] = "{{formattedFields.financials.overpayment}}";
    TemplateMention["ACCORD_TEN_PERCENT"] = "{{formattedFields.financials.tenPercentAccord}}";
    TemplateMention["ACCORD_TWENTY_PERCENT"] = "{{formattedFields.financials.twentyPercentAccord}}";
    TemplateMention["ACCORD_THIRTY_PERCENT"] = "{{formattedFields.financials.thirtyPercentAccord}}";
    TemplateMention["ACCORD_FORTY_PERCENT"] = "{{formattedFields.financials.fortyPercentAccord}}";
    TemplateMention["ACCORD_FIFTY_PERCENT"] = "{{formattedFields.financials.fiftyPercentAccord}}";
    TemplateMention["ACCORD_SIXTY_PERCENT"] = "{{formattedFields.financials.sixtyPercentAccord}}";
    TemplateMention["ACCORD_SEVENTY_PERCENT"] = "{{formattedFields.financials.seventyPercentAccord}}";
    TemplateMention["ACCORD_EIGHTY_PERCENT"] = "{{formattedFields.financials.eightyPercentAccord}}";
    TemplateMention["ACCORD_NINETY_PERCENT"] = "{{formattedFields.financials.ninetyPercentAccord}}";
    TemplateMention["LAST_PAYMENT_AMOUNT"] = "{{formattedFields.financials.lastPaymentAmount}}";
    TemplateMention["LAST_PAYMENT_DATE"] = "{{formattedFields.financials.lastPaymentDate}}";
    TemplateMention["CURRENCY"] = "{{currency}}";
    TemplateMention["PRINCIPAL_REFERENECE_IDS"] = "{{formattedFields.financials.principalReferenceIds}}";
    TemplateMention["DEPOSITS_TO_CREDITOR"] = "{{formattedFields.financials.depositedToCreditor}}";
    TemplateMention["DEPOSITS_TO_COLLECTOR"] = "{{formattedFields.financials.depositedToCollector}}";
    TemplateMention["PRINCIPALS_WITH_INTEREST"] = "{{principalsWithInterestsList}}";
    TemplateMention["DEBT_TABLE"] = "{{{debt.table}}}";
    TemplateMention["DEBT_SPECIFICATION"] = "{{debt.specification}}";
    TemplateMention["DEBT_OVERVIEW"] = "{{{debt.overview}}}";
    TemplateMention["CONTACT_NAME"] = "{{contact.name}}";
    TemplateMention["CONTACT_ADDRESS"] = "{{contact.address.address}}";
    TemplateMention["CONTACT_COADDRESS"] = "{{contact.address.coAddress}}";
    TemplateMention["CONTACT_ZIPCODE"] = "{{contact.address.zipcode}}";
    TemplateMention["CONTACT_CITY"] = "{{contact.address.city}}";
    TemplateMention["CONTACT_COUNTRY"] = "{{contact.address.country}}";
    TemplateMention["CONTACT_ADDRESS_INLINE"] = "{{contactAddressInline}}";
    TemplateMention["CONTACT_ADDRESS_FORMATTED"] = "{{contactAddressFormatted}}";
    TemplateMention["ALTERNATIVE_CONTACT_REFERENCE_ID"] = "{{contact.alternativeContactReferenceId}}";
    TemplateMention["HAS_ALTERNATIVE_CONTACT_REFERENCE_ID"] = "{{#if contact.alternativeContactReferenceId}}";
    TemplateMention["DEBTOR_ADDRESS_INLINE"] = "{{debtorAddressInline}}";
    TemplateMention["DEBTOR_ADDRESS_FORMATTED"] = "{{debtorAddressFormatted}}";
    TemplateMention["DEBTOR_NAME"] = "{{debtor.name}}";
    TemplateMention["DEBTOR_FIRST_NAME"] = "{{debtor.firstName}}";
    TemplateMention["DEBTOR_ADDRESS"] = "{{debtor.address.address}}";
    TemplateMention["DEBTOR_COADDRESS"] = "{{debtor.address.coAddress}}";
    TemplateMention["DEBTOR_ZIPCODE"] = "{{debtor.address.zipcode}}";
    TemplateMention["DEBTOR_CITY"] = "{{debtor.address.city}}";
    TemplateMention["DEBTOR_COUNTRY"] = "{{debtor.address.country}}";
    TemplateMention["DEBTOR_PHONE"] = "{{debtor.phone.number}}";
    TemplateMention["DEBTOR_EMAIL"] = "{{debtor.email}}";
    TemplateMention["DEBTOR_CVR_AND_OR_CPR"] = "{{cvrAndOrCpr}}";
    TemplateMention["DEBTOR_SEQ_ID"] = "{{debtor.id}}";
    TemplateMention["CREDITOR_NAME"] = "{{case.creditor.name}}";
    TemplateMention["CASE_ID"] = "{{case.id}}";
    TemplateMention["CASE_REFERENCE_ID"] = "{{customer.referenceId}}";
    TemplateMention["CREDITOR_ADDRESS"] = "{{case.creditor.address.address}}";
    TemplateMention["CREDITOR_ZIPCODE"] = "{{case.creditor.address.zipcode}}";
    TemplateMention["CREDITOR_CITY"] = "{{case.creditor.address.city}}";
    TemplateMention["CREDITOR_COMPANY_IDENTIFIER"] = "{{creditorCentralRegisterId}}";
    TemplateMention["CREDITOR_IF_IS_COMPANY"] = "{{#if case.creditor.isCompany}}";
    TemplateMention["USER_NAME"] = "{{user.name}}";
    TemplateMention["USER_FIRST_NAME"] = "{{user.firstName}}";
    TemplateMention["IF_USER"] = "{{#if user}}";
    TemplateMention["PAYMENT_ID"] = "{{payment.id}}";
    TemplateMention["DATE"] = "{{date}}";
    TemplateMention["DATE_IN_THREE_DAYS"] = "{{formattedFields.dateInThreeDays}}";
    TemplateMention["DATE_IN_SIX_DAYS"] = "{{formattedFields.dateInSixDays}}";
    TemplateMention["DATE_IN_TEN_DAYS"] = "{{formattedFields.dateInTenDays}}";
    TemplateMention["DATE_IN_ELEVEN_DAYS"] = "{{formattedFields.dateInElevenDays}}";
    TemplateMention["DATE_IN_TWELVE_DAYS"] = "{{formattedFields.dateInTwelveDays}}";
    TemplateMention["DATE_IN_FOURTEEN_DAYS"] = "{{formattedFields.dateInFourteenDays}}";
    TemplateMention["DATE_IN_SEVENTEEN_DAYS"] = "{{formattedFields.dateInSeventeenDays}}";
    TemplateMention["DATE_IN_THIRTY_DAYS"] = "{{formattedFields.dateInThirtyDays}}";
    TemplateMention["BANK_CREDITOR_NUMBER"] = "{{formattedFields.bankCreditorNumber}}";
    TemplateMention["DOCUMENTATION"] = "{{{documentationHTML}}}";
    TemplateMention["IF_IS_COMPANY"] = "{{#if case.isCompany}}";
    TemplateMention["IF_CASE_HAS_REMINDER_FEES"] = "{{#if formattedFields.financials.showReminderFees}}";
    TemplateMention["IF_CASE_HAS_COLLECTION_FEES"] = "{{#if formattedFields.financials.showDebtCollectionFees}}";
    TemplateMention["IF_CASE_HAS_COLLECTION_COSTS"] = "{{#if formattedFields.financials.showDebtCollectionCosts}}";
    TemplateMention["IF_CASE_HAS_COMPENSATION_COSTS"] = "{{#if formattedFields.financials.showCompensationFees}}";
    TemplateMention["IF_CASE_HAS_PROCESSRENTE"] = "{{#if formattedFields.financials.showInterests}}";
    TemplateMention["IF_CASE_HAS_FIXED_INTEREST"] = "{{#if formattedFields.financials.showFixedInterest}}";
    TemplateMention["IF_CASE_HAS_YEARLT_INTEREST"] = "{{#if formattedFields.financials.showYearlyInterest}}";
    TemplateMention["IF_CASE_HAS_DEPOSIT"] = "{{#if formattedFields.financials.hasDeposit}}";
    TemplateMention["PAYMENT_LINK"] = "{{directPaymentLink}}";
    TemplateMention["OVERPAYMENT_LINK"] = "{{overpaymentLink}}";
    TemplateMention["OVERPAYMENT_LINK_QR_CODE"] = "{{{overpaymentLinkQRCode}}}";
    TemplateMention["OVERPAYMENT_LINK_A_TAG"] = "{{overpaymentLinkATag}}";
    TemplateMention["PAYMENT_PLAN_LINK"] = "{{paymentPlanLink}}";
    TemplateMention["DEBTOR_WEB_LINK"] = "{{debtorWebLink}}";
    TemplateMention["DEBTOR_WEB_LONG_LINK"] = "{{debtorWebLongLink}}";
    TemplateMention["PAYMENT_LINK_QR_CODE"] = "{{{directPaymentLinkQRCode}}}";
    TemplateMention["PAYMENT_PLAN_LINK_QR_CODE"] = "{{{paymentPlanLinkQRCode}}}";
    TemplateMention["DEBTOR_WEB_LINK_QR_CODE"] = "{{{debtorWebLinkQRCode}}}";
    TemplateMention["PAYMENT_PLAN_LENGTH_IN_DAYS"] = "{{paymentPlan.lengthInDays}}";
    TemplateMention["PAYMENT_LINK_A_TAG"] = "{{directPaymentLinkATag}}";
    TemplateMention["PAYMENT_PLAN_LINK_A_TAG"] = "{{paymentPlanLinkATag}}";
    TemplateMention["DEBTOR_WEB_LINK_A_TAG"] = "{{debtorWebLinkATag}}";
    TemplateMention["DEBTOR_WEB_LONG_LINK_A_TAG"] = "{{debtorWebLongLinkATag}}";
    TemplateMention["PAYMENT_PLAN_ENTRIES_TAG"] = "{{paymentPlanEntriesTag}}";
    TemplateMention["PAYMENT_PLAN_CREATION_DATE"] = "{{paymentPlan.createdAt}}";
    TemplateMention["PAYMENT_PLAN_ENTRY_AMOUNT"] = "{{paymentPlan.amount}}";
    TemplateMention["PAYMENT_PLAN_ENTRY_DEADLINE"] = "{{paymentPlan.deadline}}";
    TemplateMention["PAYMENT_PLAN_ENTRY_DATE"] = "{{paymentPlan.date}}";
    TemplateMention["PAYMENT_PLAN_HTML"] = "{{{paymentPlan.planHTML}}}";
    TemplateMention["PAYMENT_PLAN_FIRST_AMOUNT"] = "{{paymentPlan.firstEntry.amount}}";
    TemplateMention["PAYMENT_PLAN_FIRST_DATE"] = "{{paymentPlan.firstEntry.date}}";
    TemplateMention["PAYMENT_PLAN_FIRST_DEADLINE"] = "{{paymentPlan.firstEntry.deadline}}";
    TemplateMention["PAYMENT_PLAN_LAST_AMOUNT"] = "{{paymentPlan.lastEntry.amount}}";
    TemplateMention["PAYMENT_PLAN_LAST_DATE"] = "{{paymentPlan.lastEntry.date}}";
    TemplateMention["PAYMENT_PLAN_LAST_DEADLINE"] = "{{paymentPlan.lastEntry.deadline}}";
    TemplateMention["PAYMENT_PLAN_YEARLY_COSTS"] = "{{{paymentPlan.yearlyCostsHTML}}}";
    TemplateMention["PAYMENT_PLAN_HAS_YEARLY_INTEREST"] = "{{#if paymentPlan.hasYearlyInterest}}";
    TemplateMention["PAYMENT_PLAN_MIN_ENTRY_AMOUNT"] = "{{paymentPlan.minEntryAmount}}";
    TemplateMention["PAYMENT_PLAN_MAX_ENTRY_AMOUNT"] = "{{paymentPlan.maxEntryAmount}}";
    TemplateMention["SIGNATURE_TIRANA"] = "{{signatures.tirana}}";
    TemplateMention["SIGNATURE_MICHAEL_BRANDT"] = "{{signatures.michael_brandt}}";
    TemplateMention["BPK"] = "{{betalingspaakrav}}";
    TemplateMention["PAGE_BREAK"] = "{{pageBreak}}";
    TemplateMention["RKI_WARNING"] = "{{rkiWarning}}";
    TemplateMention["JOURNAL_NUMBER"] = "{{journalNumber}}";
    TemplateMention["COLLECTOR_PAYMENT_OPTIONS"] = "{{{paymentOptionsHTML}}}";
    TemplateMention["COLLECTOR_REGISTER_NUMBER"] = "{{collector.registrationNumber}}";
    TemplateMention["COLLECTOR_ACCOUNT_NUMBER"] = "{{collector.accountNumber}}";
    TemplateMention["COLLECTOR_PHONE"] = "{{collectorPhone}}";
    TemplateMention["COLLECTOR_EMAIL"] = "{{collectorEmail}}";
    TemplateMention["COLLECTOR_NICKNAME"] = "{{collector.nickname}}";
    TemplateMention["COLLECTOR_NAME"] = "{{collector.name}}";
    TemplateMention["COLLECTOR_ADDRESS_ADDRESS"] = "{{collector.address.address}}";
    TemplateMention["COLLECTOR_ADDRESS_CITY"] = "{{collector.address.city}}";
    TemplateMention["COLLECTOR_ADDRESS_ZIP"] = "{{collector.address.zipcode}}";
    TemplateMention["COLLECTOR_CVR"] = "{{collector.centralRegisterId}}";
    TemplateMention["COLLECTOR_COURT_PHONE"] = "{{collectorCourtPhone}}";
    TemplateMention["IF_COLLECTOR_ALLOWS_BANK_TRANSFERS"] = "{{#if availablePaymentOptions.bankTransfer}}";
    TemplateMention["IF_COLLECTOR_ALLOWS_FI_PAYMENTS"] = "{{#if availablePaymentOptions.fi}}";
    TemplateMention["CIVIL_COURT_NAME"] = "{{court.navn}}";
    TemplateMention["CIVIL_COURT_ADDRESS"] = "{{court.address.address}}";
    TemplateMention["CIVIL_COURT_CITY"] = "{{court.address.city}}";
    TemplateMention["CIVIL_COURT_ZIP"] = "{{court.address.zipcode}}";
    TemplateMention["CIVIL_COURT_EMAIL"] = "{{court.email}}";
    TemplateMention["CIVIL_COURT_PHONE"] = "{{court.phone}}";
    TemplateMention["CIVIL_COURT_EAN"] = "{{court.eanno}}";
    TemplateMention["CIVIL_ACCOUNT_NO"] = "{{court.accountnumber}}";
    TemplateMention["CIVIL_REG_NO"] = "{{court.registrationnumber}}";
    TemplateMention["SIGN_FIELDS"] = "{{sign.fields}}";
    TemplateMention["SATISFACTION_BUTTONS"] = "{{satisfaction.buttons}}";
    TemplateMention["FOUNDATION_DATE"] = "{{foundationDate}}";
    TemplateMention["FOUNDATION_TYPE"] = "{{foundationType}}";
    TemplateMention["LATEST_TRIBUNAL_REFERENCE"] = "{{tribunal.latestReferenceId}}";
    TemplateMention["CONDITIONAL_END_IF"] = "{{/if}}";
    TemplateMention["CONDITIONAL_ELSE"] = "{{else}}";
})(TemplateMention || (exports.TemplateMention = TemplateMention = {}));
const BasicTemplateMentionSuggestions = [
    TemplateMention.FINANCIALS_PRICIPAL,
    TemplateMention.FINANCIALS_DEBT_COLLECTION_FEES,
    TemplateMention.FINANCIALS_ADMINISTRATION_COSTS,
    TemplateMention.FINANCIALS_COMPENSATION_FEES,
    TemplateMention.FINANCIALS_INTERESTS,
    TemplateMention.FINANCIALS_DEBT_COLLECTION_COSTS,
    TemplateMention.PAYMENT_PLAN_FIRST_AMOUNT,
    TemplateMention.PAYMENT_PLAN_FIRST_DEADLINE,
    TemplateMention.PAYMENT_PLAN_FIRST_DATE,
    TemplateMention.PAYMENT_PLAN_LAST_AMOUNT,
    TemplateMention.PAYMENT_PLAN_LAST_DEADLINE,
    TemplateMention.PAYMENT_PLAN_YEARLY_COSTS,
    TemplateMention.PAYMENT_PLAN_HAS_YEARLY_INTEREST,
    TemplateMention.PAYMENT_PLAN_MIN_ENTRY_AMOUNT,
    TemplateMention.PAYMENT_PLAN_MAX_ENTRY_AMOUNT,
    TemplateMention.PAYMENT_PLAN_LAST_DATE,
    TemplateMention.PAYMENT_PLAN_ENTRY_AMOUNT,
    TemplateMention.PAYMENT_PLAN_ENTRY_DEADLINE,
    TemplateMention.PAYMENT_PLAN_ENTRY_DATE,
    TemplateMention.PAYMENT_PLAN_CREATION_DATE,
    TemplateMention.TOTAL_DEBT,
    TemplateMention.OVERPAYMENT,
    TemplateMention.CURRENCY,
    TemplateMention.PRINCIPAL_REFERENECE_IDS,
    TemplateMention.ACCORD_TEN_PERCENT,
    TemplateMention.ACCORD_TWENTY_PERCENT,
    TemplateMention.ACCORD_THIRTY_PERCENT,
    TemplateMention.ACCORD_FORTY_PERCENT,
    TemplateMention.ACCORD_FIFTY_PERCENT,
    TemplateMention.ACCORD_SIXTY_PERCENT,
    TemplateMention.ACCORD_SEVENTY_PERCENT,
    TemplateMention.ACCORD_EIGHTY_PERCENT,
    TemplateMention.ACCORD_NINETY_PERCENT,
    TemplateMention.IF_IS_COMPANY,
    TemplateMention.IF_CASE_HAS_REMINDER_FEES,
    TemplateMention.IF_CASE_HAS_COLLECTION_FEES,
    TemplateMention.IF_CASE_HAS_COLLECTION_COSTS,
    TemplateMention.IF_CASE_HAS_COMPENSATION_COSTS,
    TemplateMention.IF_CASE_HAS_PROCESSRENTE,
    TemplateMention.IF_CASE_HAS_FIXED_INTEREST,
    TemplateMention.IF_CASE_HAS_YEARLT_INTEREST,
    TemplateMention.IF_CASE_HAS_DEPOSIT,
    TemplateMention.IF_COLLECTOR_ALLOWS_BANK_TRANSFERS,
    TemplateMention.IF_COLLECTOR_ALLOWS_FI_PAYMENTS,
    TemplateMention.DATE,
    TemplateMention.DATE_IN_THREE_DAYS,
    TemplateMention.DATE_IN_SIX_DAYS,
    TemplateMention.DATE_IN_TEN_DAYS,
    TemplateMention.DATE_IN_ELEVEN_DAYS,
    TemplateMention.DATE_IN_TWELVE_DAYS,
    TemplateMention.DATE_IN_FOURTEEN_DAYS,
    TemplateMention.DATE_IN_SEVENTEEN_DAYS,
    TemplateMention.DATE_IN_THIRTY_DAYS,
    TemplateMention.DEPOSIT,
    TemplateMention.DEPOSITS_TO_COLLECTOR,
    TemplateMention.DEPOSITS_TO_CREDITOR,
    TemplateMention.PRINCIPALS_WITH_INTEREST,
    TemplateMention.CONTACT_NAME,
    TemplateMention.DEBTOR_NAME,
    TemplateMention.DEBTOR_FIRST_NAME,
    TemplateMention.CONTACT_ADDRESS,
    TemplateMention.CONTACT_COADDRESS,
    TemplateMention.CONTACT_ZIPCODE,
    TemplateMention.CONTACT_CITY,
    TemplateMention.CONTACT_COUNTRY,
    TemplateMention.ALTERNATIVE_CONTACT_REFERENCE_ID,
    TemplateMention.HAS_ALTERNATIVE_CONTACT_REFERENCE_ID,
    TemplateMention.DEBTOR_ADDRESS,
    TemplateMention.DEBTOR_COADDRESS,
    TemplateMention.DEBTOR_ZIPCODE,
    TemplateMention.DEBTOR_CITY,
    TemplateMention.DEBTOR_COUNTRY,
    TemplateMention.DEBTOR_EMAIL,
    TemplateMention.DEBTOR_PHONE,
    TemplateMention.LAST_PAYMENT_DATE,
    TemplateMention.LAST_PAYMENT_AMOUNT,
    TemplateMention.DEBTOR_SEQ_ID,
    TemplateMention.DEBTOR_CVR_AND_OR_CPR,
    TemplateMention.CREDITOR_NAME,
    TemplateMention.CASE_ID,
    TemplateMention.CASE_REFERENCE_ID,
    TemplateMention.CREDITOR_ADDRESS,
    TemplateMention.REMINDER_FEES,
    TemplateMention.COLLECTOR_PAYMENT_OPTIONS,
    TemplateMention.COLLECTOR_ACCOUNT_NUMBER,
    TemplateMention.COLLECTOR_REGISTER_NUMBER,
    TemplateMention.COLLECTOR_PHONE,
    TemplateMention.COLLECTOR_COURT_PHONE,
    TemplateMention.COLLECTOR_EMAIL,
    TemplateMention.COLLECTOR_NICKNAME,
    TemplateMention.COLLECTOR_NAME,
    TemplateMention.COLLECTOR_ADDRESS_ADDRESS,
    TemplateMention.COLLECTOR_ADDRESS_ZIP,
    TemplateMention.COLLECTOR_ADDRESS_CITY,
    TemplateMention.COLLECTOR_CVR,
    TemplateMention.PAYMENT_PLAN_LENGTH_IN_DAYS,
    TemplateMention.CREDITOR_ZIPCODE,
    TemplateMention.CREDITOR_CITY,
    TemplateMention.CREDITOR_COMPANY_IDENTIFIER,
    TemplateMention.CREDITOR_IF_IS_COMPANY,
    TemplateMention.USER_NAME,
    TemplateMention.USER_FIRST_NAME,
    TemplateMention.IF_USER,
    TemplateMention.PAYMENT_ID,
    TemplateMention.JOURNAL_NUMBER,
    TemplateMention.GENERIC_EMAIL_SUBJECT,
    TemplateMention.CIVIL_COURT_NAME,
    TemplateMention.CIVIL_COURT_ADDRESS,
    TemplateMention.CIVIL_COURT_CITY,
    TemplateMention.CIVIL_COURT_ZIP,
    TemplateMention.CIVIL_COURT_EMAIL,
    TemplateMention.CIVIL_COURT_PHONE,
    TemplateMention.CIVIL_COURT_EAN,
    TemplateMention.CIVIL_REG_NO,
    TemplateMention.CIVIL_ACCOUNT_NO,
    TemplateMention.FOUNDATION_DATE,
    TemplateMention.FOUNDATION_TYPE,
    TemplateMention.LATEST_TRIBUNAL_REFERENCE,
    TemplateMention.CONDITIONAL_ELSE,
    TemplateMention.CONDITIONAL_END_IF,
];
exports.TemplateMentionSuggestions = [
    ...BasicTemplateMentionSuggestions,
    TemplateMention.PAYMENT_PLAN_HTML,
    TemplateMention.CONTACT_ADDRESS_INLINE,
    TemplateMention.CONTACT_ADDRESS_FORMATTED,
    TemplateMention.DEBTOR_ADDRESS_INLINE,
    TemplateMention.DEBTOR_ADDRESS_FORMATTED,
    TemplateMention.DEBT_TABLE,
    TemplateMention.DEBT_SPECIFICATION,
    TemplateMention.DEBT_OVERVIEW,
    TemplateMention.SIGN_FIELDS,
];
exports.LetterTemplateMentionSuggestions = [
    ...exports.TemplateMentionSuggestions,
    TemplateMention.BPK,
    TemplateMention.PAGE_BREAK,
    TemplateMention.OVERPAYMENT_LINK,
    TemplateMention.PAYMENT_LINK,
    TemplateMention.PAYMENT_PLAN_LINK,
    TemplateMention.PAYMENT_LINK_QR_CODE,
    TemplateMention.PAYMENT_PLAN_LINK_QR_CODE,
    TemplateMention.DEBTOR_WEB_LINK_QR_CODE,
    TemplateMention.OVERPAYMENT_LINK_QR_CODE,
    TemplateMention.DEBTOR_WEB_LINK,
    TemplateMention.DEBTOR_WEB_LONG_LINK_A_TAG,
    TemplateMention.DOCUMENTATION,
];
exports.EBoksTemplateMentionSuggestions = [
    ...exports.TemplateMentionSuggestions,
    TemplateMention.BPK,
    TemplateMention.PAGE_BREAK,
    TemplateMention.OVERPAYMENT_LINK,
    TemplateMention.PAYMENT_LINK,
    TemplateMention.PAYMENT_PLAN_LINK,
    TemplateMention.PAYMENT_LINK_QR_CODE,
    TemplateMention.PAYMENT_PLAN_LINK_QR_CODE,
    TemplateMention.DEBTOR_WEB_LINK_QR_CODE,
    TemplateMention.DEBTOR_WEB_LONG_LINK_A_TAG,
    TemplateMention.DOCUMENTATION,
];
exports.SMSTemplateMentionSuggestions = [
    ...BasicTemplateMentionSuggestions,
    TemplateMention.OVERPAYMENT_LINK,
    TemplateMention.PAYMENT_LINK,
    TemplateMention.PAYMENT_PLAN_LINK,
    TemplateMention.DEBTOR_WEB_LINK,
];
exports.EmailTemplateMentionSuggestions = [
    ...exports.TemplateMentionSuggestions,
    TemplateMention.OVERPAYMENT_LINK_A_TAG,
    TemplateMention.PAYMENT_LINK_A_TAG,
    TemplateMention.SATISFACTION_BUTTONS,
    TemplateMention.PAYMENT_PLAN_LINK_A_TAG,
    TemplateMention.DEBTOR_WEB_LINK_A_TAG,
    TemplateMention.PAYMENT_PLAN_ENTRIES_TAG,
    TemplateMention.DOCUMENTATION,
];
exports.TemplateMentionReplacements = [
    {
        mention: TemplateMention.USER_NAME,
        value: `{{user.firstName}} {{user.lastName}}`,
    },
    {
        mention: TemplateMention.PAYMENT_LINK_A_TAG,
        value: `<a href="{{directPaymentLink}}">{{directPaymentLink}}</a>`,
    },
    {
        mention: TemplateMention.COLLECTOR_EMAIL,
        value: `{{#if collector.replyTo }}{{ collector.replyTo }}{{ else }}{{ collector.email }}{{/if}}`,
    },
    {
        mention: TemplateMention.OVERPAYMENT_LINK_A_TAG,
        value: `<a href="{{overpaymentLink}}">{{overpaymentLink}}</a>`,
    },
    {
        mention: TemplateMention.PAYMENT_PLAN_ENTRIES_TAG,
        value: `<style>.table.entries tr td th{ padding: 5px !important; font-size: 0.8em; }</style><table class="zebra table entries">
      <thead>
        <th>{{lang.debtorWebPaymentPlans.amount}}</th>
        <th>{{lang.debtorWebPaymentPlans.date}}</th>
        <th>{{lang.debtorWebPaymentPlans.status}}</th>
      </thead>
      <tbody>
       {{#each entries}}
        <tr>
          <td>{{this.amount}}</td>
          <td>{{this.date}}</td>
          <td>{{this.status}}</td>
        </tr>
       {{/each}}
      </tbody>
    </table>`,
    },
    {
        mention: TemplateMention.CREDITOR_COMPANY_IDENTIFIER,
        value: `{{#if case.creditor.centralRegisterId }}{{ case.creditor.centralRegisterId }}{{else}}{{ case.creditor.properties.company.localIdentifier }}{{/if}}`,
    },
    {
        mention: TemplateMention.DEBTOR_CVR_AND_OR_CPR,
        value: '{{#if debtor.cpr }}CPR: {{debtor.cpr}}{{/if}}{{#if debtor.cpr }}{{#if debtor.cvr }}, {{/if}}{{/if}}{{#if debtor.cvr }}CVR: {{debtor.cvr}}{{/if}}',
    },
    {
        mention: TemplateMention.COLLECTOR_COURT_PHONE,
        value: `{{#if tribunal.settings.courtPhone }}{{ tribunal.settings.courtPhone }}{{else}}+{{ collector.phone.locale }} {{ collector.phone.number }}{{/if}}`,
    },
    {
        mention: TemplateMention.PAYMENT_PLAN_LINK_A_TAG,
        value: `<a href="{{paymentPlanLink}}">{{paymentPlanLink}}</a>`,
    },
    {
        mention: TemplateMention.DEBTOR_WEB_LINK_A_TAG,
        value: `<a href="{{debtorWebLink}}">{{debtorWebLink}}</a>`,
    },
    {
        mention: TemplateMention.DEBTOR_WEB_LONG_LINK_A_TAG,
        value: `<a href="{{debtorWebLongLink}}">{{debtorWebLongLink}}</a>`,
    },
    {
        mention: TemplateMention.PAGE_BREAK,
        value: `<div class="page-break"></div>`,
    },
    {
        mention: TemplateMention.COLLECTOR_PHONE,
        value: `+{{collector.phone.locale}} {{collector.phone.number}}`,
    },
    {
        mention: TemplateMention.SATISFACTION_BUTTONS,
        value: `<p><a href="{{satisfactions.frown}}"><img style="height: 50px;display: inline-block;" src="https://api.debbiecollect.com/files/29e590fb-ca99-45e7-9b89-8f9810c26718/frown.png" /></a><a href="{{satisfactions.meh}}"><img style="height: 50px;display: inline-block;" src="https://api.debbiecollect.com/files/3a5f1528-98b4-4e7d-8c02-b61ec6a68d56/meh.png" /></a><a href="{{satisfactions.smile}}"><img style="height: 50px;display: inline-block;" src="https://api.debbiecollect.com/files/607aa9ba-6af5-4bc6-9bc4-65b29e8cb908/smile.png" /></a></p><p style="margin-top: -0.9em;font-size: 0.9em;color: grey;">{{lang.mentionContent.satisfactionsOrClick}} <a href="{{satisfactions.base}}">{{lang.mentionContent.satisfactionsHere}}</a></p>`,
    },
    {
        mention: TemplateMention.DEBT_SPECIFICATION,
        value: `<table style="width: 100%">
      <tr style="text-align: left">
        <th>
          {{lang.mentionContent.invoice}}
        </th>
        <th>
          {{lang.mentionContent.date}}
        </th>
        <th>
          {{lang.mentionContent.dueDate}}
        </th>
        <th style="text-align: right">
          {{lang.mentionContent.amount}}
        </th>
      </tr>
      {{#each formattedFields.financials.principals}}
      <tr style="break-inside: avoid">
        <td>{{this.referenceId}}</td>
        <td>{{this.issueDate}}</td>
        <td>{{this.dueDate}}</td>
        <td style="text-align: right">{{../currency}} {{this.amount}}</td>
      </tr>
      {{/each}}
    </table>`,
    },
    {
        mention: TemplateMention.PAYMENT_ID,
        value: `+71&lt;{{formattedFields.fiPaymentId}} + {{collector.fiCreditorNumber}}&lt;`,
    },
    {
        mention: TemplateMention.BPK,
        value: `
    <style>
      * {
        font-family: "Times New Roman", Times, serif !important;
      }

      body {
        padding: 0 55px !important;
        font-size: 0.8em;
      }

      h1, h2, h3, h4, h5, h6 {
        font-size: 1.5em !important;
        font-weight: 900 !important;
        text-align: left !important;
      }
      .border-table {
        border-collapse: collapse;
      }

      .border-table td {
        padding: 5px;
        border: 1px solid black;
      }
    </style>
    <main>
    <table class="full-table border-table" border="1|0">
      <tr>
        <td>
          Retskreds:
          <br>
          <b>{{court.name}}</b>
          <br>{{court.address}},
          <br>{{court.zipcode}} {{court.city}}
          <br>
          <br>
          <small>Email: {{court.emailFogedretIndleveringBPK}} &bull; Tlf.: {{court.phone}} &bull; Reg.nr.: {{court.registrationnumber}}, kontonr.: {{court.accountnumber}}</small>
          <br>
        </td>
      </tr>
    </table>
    <h1>Betalingspåkrav</h1>
    <p>Kreditor skal udfylde og bruge denne blanket som betalingspåkrav ved indledningen af en forenklet inkassoproces,
    jf. retsplejelovens
    kap. 44 a. Det samlede krav må højst være på 100.000 kr. uden renter og omkostninger. Du kan finde vejledning om
    udfyldelse
    af blanketten på domstol.dk.</p>
    <table class="full-table border-table" border="1|0">
      <tr>
        <td class="small-cell grey">
          <h1 class="small-line">Kreditor (og eventuel repræsentant):</h1>
        </td>
        <td class="small-cell center fifth">
          <h1 class="small-line center">Rubrik 1</h1>
        </td>
      </tr>
      <tr>
        <td colspan="2">
          Skriv kreditors og eventuel repræsentants navn, adresse, telefonnummer, mailadresse, cvr-nummer og
          sagsnummer. Hvis adressen
          er udenlandsk, skal du også skrive den postadresse i det Europæiske Økonomiske Samarbejdsområde, som breve,
          indkaldelser
          m.m. kan sendes til i forbindelse med sagen.
        </td>
      </tr>
    </table>
    <table class="full-table border-table fiftyfifty" border="1|0">
      <tr>
        <td class="align-top">
          <b>Kreditor:</b>
          <br> {{ case.creditor.name }}
          <br> {{ case.creditor.address.address }}
          <br> {{ case.creditor.address.zipcode }} {{ case.creditor.address.city }}
          <br> Cvr.: {{#if case.creditor.centralRegisterId}}{{case.creditor.centralRegisterId}}{{else}}{{case.creditor.properties.company.localIdentifier}}{{/if}}
          {{#if selfCollection }}
            <br>
            <br>
            <br>
            <br>
            <br>
            <br>
            <br>Kreditors registrerings- og kontonummer:
            <br>
            {{#if tribunal.settings.courtRegistrationNumber }}{{ tribunal.settings.courtRegistrationNumber }} {{tribunal.settings.courtAccountNumber}}{{else}}{{collector.registrationNumber}} {{collector.accountNumber}}{{/if}}
          {{/if}}
        </td>
        <td>
          <b>Eventuel repræsentant:</b>
          {{#if selfCollection }}
            <br>
            <br>
            <br>
            <br>
            <br>
            <br>
            <br>
            <br>
            <br>
            <br>
            <br>
            <br>
          {{else}}
            <br> {{collector.name}}
            <p>{{ collector.address.address }}
            <br>
              DK-{{collector.address.zipcode}} {{ collector.address.city }}
            <br>
            Cvr.: {{ collector.centralRegisterId }}
            <br> {{#if tribunal.settings.courtEmail }}{{ tribunal.settings.courtEmail }}{{else}}{{#if collector.replyTo }}{{ collector.replyTo }}{{ else }}{{ collector.email }}{{/if}}{{/if}}
            <br>
            <br>
            <br>
            <br>
            <br> Repræsentantens registrerings- og kontonummer:
            <br>
            {{#if tribunal.settings.courtRegistrationNumber }}{{ tribunal.settings.courtRegistrationNumber }} {{tribunal.settings.courtAccountNumber}}{{else}}{{collector.registrationNumber}} {{collector.accountNumber}}{{/if}}
          {{/if}}
        </td>
      </tr>
      <tr>
        <td>
          <p>Kreditors registrerings- og kontonummer:<br>
          {{case.creditor.properties.registernumber}} {{case.creditor.properties.accountnumber}}
          </p>
          <p>Er kreditor momsregistreret? {{#if case.creditor.vatRegistered}}Ja: ☒ Nej: ☐{{else}}Ja: ☐ Nej: ☒{{/if}}</p>
        </td>
        <td>
          <p>Ved evt. telefonmøde kan fogedretten ringe til tlf.nr.:<br>{{#if tribunal.settings.courtPhone }}{{ tribunal.settings.courtPhone }}{{else}}+{{ collector.phone.locale }} {{ collector.phone.number }}{{/if}}</p>
          <p>Repræsentantens sagsnummer:<br>
          {{case.id}}-{{contact.id}}</p>
        </td>
      </tr>
    </table>
    <br>
    <br>
    <table class="full-table border-table" border="1|0">
      <tr>
        <td class="small-cell grey">
          <h1 class="small-line">Skyldner:</h1>
        </td>
        <td class="small-cell center fifth" style="width: 20% !important;">
          <h1 class="small-line center">Rubrik 2</h1>
        </td>
      </tr>
      <tr>
        <td colspan="2">
          Skriv skyldners navn, adresse og om muligt mailadresse, telefonnummer, cvr-nummer og eventuelle
          opholdsadresse.
        </td>
      </tr>
      </tr>
    </table>
    <table class="full-table fiftyfifty border-table" border="1|0">
      <tr>
        <td style="border-right: none !important;">
          <b>Skyldner:</b>
          <br>
          <strong>{{debtor.name}}</strong>
          <br> {{debtor.address.address}}{{#if debtor.address.coAddress}}, c/o {{debtor.address.coAddress}}{{/if}}
          <br> {{debtor.address.zipcode}} {{debtor.address.city}}
          <br> {{debtor.address.country}}
          <br> {{#if case.isCompany}}{{#if debtor.cvr }}CVR: {{debtor.cvr}}{{/if}}{{/if}}
          <br> {{#if debtor.email}}Email: {{debtor.email}}{{/if}}
          <br> {{#if debtor.phone}}Telefon: +{{debtor.phone.locale}} {{debtor.phone.number}}{{/if}}
          <br>
          <br>
          <br>
        </td>
        <td style="border-left: none !important;">
          {{#if case.isCompany}}
            {{#if fuldtAnsvarligDeltagere}}
            <b>Fuldt ansvarlig deltager:</b>
            <br>
            {{#each fuldtAnsvarligDeltagere}}
              <strong>{{this.name}}</strong>
              {{#if this.address.address}}{{#if this.address.zipcode}}{{#if this.address.city}}
                <br> {{this.address.address}}
                <br> {{this.address.zipcode}} {{this.address.city}}
                <br> {{this.address.country}}<br><br>
              {{/if}}{{/if}}{{/if}}
            {{/each}}
            {{/if}}
          {{/if}}
        </td>
      </tr>
    </table>
    <table class="full-table border-table" border="1|0">
      <tr>
        <td colspan="2">
          Hvis skyldner er et selskab/forening – skriv om muligt direktørens/formandens navn og adresse:<br>{{#if case.isCompany}}{{#if director}}{{director.name}}{{#if director.address.address}}, {{director.address.address}}, {{director.address.zipcode}} {{director.address.city}}{{/if}}{{/if}}{{/if}}
        </td>
      </tr>
    </table>
    <div class="page-break"></div>
    <p>
    Betalingspåkravet bliver indleveret til
    </p>
    <table class="full-table border-table" border="1|0">
      <tr>
        <td class="small-cell grey fifth" style="width: 130px;">
          <p>
            <h1 class="small-line">Fogedretten i:</h1>
          </p>
        </td>
        <td class="small-cell">
          <h1 class="small-line">{{court.name}}</h1>
        </td>
        <td class="small-cell center fifth">
          <p>
            <h1 class="small-line center">Rubrik 3</h1>
          </p>
        </td>
      </tr>
    </table>
    <br>
    <table class="full-table border-table" border="1|0">
      <tr>
        <td class="small-cell grey">
          <h1 class="small-line">Kravets størrelse</h1>
        </td>
        <td class="small-cell center fifth">
          <h1 class="small-line center">Rubrik 4</h1>
        </td>
      </tr>
      <tr>
        <td colspan="2">
          Du skal specificere kravets størrelse i hovedstol (gældens størrelse uden renter og omkostninger) og
          eventuelle renter, gebyrer
          og andre udenretlige omkostninger:
        </td>
      </tr>
      <tr>
        <td>
          <b>Hovedstol:</b>
        </td>
        <td class="fifth" style="text-align: right;">
          <b>{{formattedFields.financials.principal}}</b> <small>kr.</small>
        </td>
      </tr>
    </table>
    <table class="full-table border-table" border="1|0">
      <tr>
        <td rowspan="4" style="width: 55px;">
          <p>
            <b>
              Renter:
            </b>
          </p>
          <p>
            Sæt kryds
          </p>
        </td>
        <td rowspan="2">{{#if processInterest}}☒{{else}}☐{{/if}}</td>
        <td rowspan="2">Procesrente</td>
        <td>{{#if processInterest}}{{#if interestFromSubmitOfBPK}}☒{{else}}☐{{/if}}{{else}}☐{{/if}} fra indlevering af betalingspåkravet
          <b>eller</b>
        </td>
        <td rowspan="4" class="fifth">
        </td>
      </tr>
      <tr>
        <td>{{#if processInterest}}{{#if interestFromSubmitOfBPK}}☐ fra dato:{{else}}☒ fra dato: {{interestDates}}{{/if}}{{else}}☐ fra dato:{{/if}}</td>
      </tr>
      <tr>
        <td rowspan="2">{{#if processInterest}}☐{{else}}☒{{/if}}</td>
        <td rowspan="2">{{#if processInterest}}Med _.__ % <br>pro anno{{else}}Med {{caseInterest}} %<br>pro anno{{/if}}</td>
        <td>{{#if processInterest}}☐{{else}}{{#if interestFromSubmitOfBPK}}☒{{else}}☐{{/if}}{{/if}} fra indlevering af betalingspåkravet
          <b>eller</b>
        </td>
      </tr>
      <tr>
        <td>{{#if processInterest}}☐ fra dato:{{else}}{{#if interestFromSubmitOfBPK}}☐ fra dato:{{else}}☒ fra dato: {{interestDates}}{{/if}}{{/if}}</td>
      </tr>
    </table>
    <table class="full-table border-table" border="1|0">
      <tr>
        <td>
          Allerede påløbne renter frem til betalingspåkravets indlevering
        </td>
        <td class="fifth" style="text-align: right;">
          <b>{{interests}}</b> <small>kr.</small>
        </td>
      </tr>
    </table>
    <table class="full-table border-table" border="1|0">
      <tr>
        <td rowspan="4" style="width: 200px;">
          Eventuelle udenretlige omkostninger
        </td>
        <td>
          Rykkergebyr(er)
        </td>
        <td class="fifth" style="text-align: right;">
          <b>{{formattedFields.financials.reminderFees}}</b> <small>kr.</small>
        </td>
      </tr>
      <tr>
        <td>
          Inkassogebyr
        </td>
        <td class="fifth" style="text-align: right;">
          <b>{{formattedFields.financials.debtCollectionFees}}</b> <small>kr.</small>
        </td>
      </tr>
      <tr>
        <td>
          Andre omkostninger (f.eks. omkostninger til egen- inkasso og/eller fremmedinkasso)
        </td>
        <td class="fifth" style="text-align: right;">
          <b>{{formattedFields.financials.otherCostsBPK}}</b> <small>kr.</small>
        </td>
      </tr>
      <tr>
        <td>
          Kompensationsbeløb (ikke i forbrugerforhold)
        </td>
        <td class="fifth" style="text-align: right;">
          <b>{{formattedFields.financials.compensationFees}}</b> <small>kr.</small>
        </td>
      </tr>
      <tr>
        <td colspan="2">
          <b>I alt:</b>
        </td>
        <td class="fifth" style="text-align: right;">
          <b>{{totalAmount}}</b> <small>kr.</small>
        </td>
      </tr>
    </table>
    <br>
    <table class="full-table border-table" border="1|0">
      <tr>
        <td class="small-cell grey">
          <h1 class="small-line">Sagsfremstilling:</h1>
        </td>
        <td class="small-cell center fifth">
          <h1 class="small-line center">Rubrik 5</h1>
        </td>
      </tr>
      <tr>
        <td colspan="2">
          Betalingspåkravet skal i denne rubrik indeholde en kort beskrivelse af de faktiske og retlige omstændigheder,
          som kravet
          er begrundet med. Du skal skrive, hvad beløbene i rubrik 4 skyldes for og begrunde renter ud over
          procesrenter
          fra indlevering af betalingspåkravet, gebyrer og udenretlige omkostninger mv.
        </td>
      </tr>
      <tr>
        <td colspan="2">
          {{{content}}}
        </td>
      </tr>
    </table>
    <div class="page-break"></div>
    <table class="full-table border-table" border="1|0">
      <tr>
        <td class="small-cell grey">
          <h1 class="small-line">
              Kreditor skal oplyse, om inkassolovens krav om rykkerbrev er opfyldt:
          </h1>
        </td>
        <td class="small-cell center fifth">
          <h1 class="small-line center">Rubrik 6</h1>
        </td>
      </tr>
      <tr>
        <td colspan="2">
          Inden indleveringen af betalingspåkravet skal du sende et rykkerbrev (en påkravsskrivelse) til skyldner.
          Rykkerbrevet skal
          opfylde betingelserne i inkassolovens § 10, jf. dog § 11.
        </td>
      </tr>
    </table>
    <table class="full-table border-table" border="1|0">
      <tr>
        <td class="fourth">
          Rykkerbrev er sendt den:
        </td>
        <td>
          {{ remindingDate }}
        </td>
      </tr>
    </table>
    <br>
    <table class="full-table border-table" border="1|0">
      <tr>
        <td class="small-cell grey" rowspan="2">
          <h1 class="small-line">Kreditor skal oplyse, hvordan sagen skal forløbe i følgende situationer:</h1>
        </td>
        <td class="small-cell center fifth" colspan="2">
          <h1 class="small-line center">Rubrik 7</h1>
        </td>
      </tr>
      <tr class="center">
        <td>
          Ja
        </td>
        <td>
          Nej
        </td>
      </tr>
      <tr>
        <td>
          Ønsker du betalingspåkravet forkyndt, hvis skyldner har afgivet insolvenserklæring i fogedretten, eller er
          under rekonstruktion,
          konkurs eller gældssanering og derfor er beskyttet mod udlæg?
        </td>
        <td class="center">
          {{#if preventForkyndt}}☐{{else}}☒{{/if}}
        </td>
        <td class="center">
          {{#if preventForkyndt}}☒{{else}}☐{{/if}}
        </td>
      </tr>
      <tr>
        <td>
          Ønsker du, at fogedretten automatisk skal iværksætte udlæg, hvis skyldner
          <b>ikke</b> kommer med indsigelser (protester) mod dit krav?
        </td>
        <td class="center">
          {{#if preventAutDistress}}☐{{else}}☒{{/if}}
        </td>
        <td class="center">
          {{#if preventAutDistress}}☒{{else}}☐{{/if}}
        </td>
      </tr>
      <tr>
        <td>
          Ønsker du, at retssag automatisk skal indledes i civilretten på grundlag af betalingspåkravet, hvis skyldner
          kommer med indsigelser
          (protester) mod dit krav?
        </td>
        <td class="center">
          {{#if notDirectlyToCivilCourt}}☐{{else}}☒{{/if}}
        </td>
        <td class="center">
          {{#if notDirectlyToCivilCourt}}☒{{else}}☐{{/if}}
        </td>
      </tr>
    </table>
    <br>
    <table class="full-table border-table" border="1|0">
      <tr>
        <td class="small-cell grey">
          <h1 class="small-line">Retsafgift:</h1>
        </td>
        <td class="small-cell center fifth">
          <h1 class="small-line center">Rubrik 8</h1>
        </td>
      </tr>
      <tr>
        <td>
          Skriv den samlede indbetalte retsafgift:
        </td>
        <td class="right">
          <div style="text-align: right;">
            <b>{{courtFee}}</b> <small>kr.</small>
          </div>
        </td>
      </tr>
    </table>
    <table class="full-table border-table" border="1|0">
      <tr>
        <td rowspan="2">
          Betalingsmåde
        </td>
        <td>
          ☒
        </td>
        <td>
          Retsafgiften er indbetalt til fogedretten via overførsel til fogedrettens kontonummer
        </td>
      </tr>
      <tr>
        <td>
          ☐
        </td>
        <td>
          Anden betalingsmåde – skriv hvilken:
        </td>
      </tr>
    </table>
    <br>
    <table class="full-table border-table" border="1|0">
      <tr>
        <td class="small-cell grey fifth">
          <h1 class="small-line">Dato:</h1>
        </td>
        <td class="small-cell grey">
          <h1 class="small-line">Indsendt af (kreditor eller kreditors repræsentant):</h1>
        </td>
        <td class="small-cell center fifth">
          <h1 class="small-line center">Rubrik 9</h1>
        </td>
      </tr>
      <tr>
        <td>
          {{createDate}}
        </td>
        <td colspan="2">
          {{tribunal.settings.courtRepresentative}}
        </td>
      </tr>
    </table>
    <table class="full-table border-table" border="1|0">
      <tr>
        <td>
          Jeg giver hermed samtykke til, at al korrespondance i sagen kan sendes digitalt, f.eks. til e-boks (sæt
          kryds)
        </td>
        <td class="center sixth">
          ☒
        </td>
      </tr>
    </table>
  </main>
    `,
    },
    {
        mention: TemplateMention.PRINCIPALS_WITH_INTEREST,
        value: `{{#each principalsWithInterest}}
      <p>{{this.date}} Faktura nr. {{this.referenceId}}, kr. {{this.amount}}. Procesrente fra {{this.interestStartDate}}, opgjort til kr. {{this.interestAmount}}.</p>
    {{/each}}`,
    },
    {
        mention: TemplateMention.GENERIC_EMAIL_SUBJECT,
        value: `{{#if contact.isAlternativeContact}}{{lang.mentionContent.genericEmailSubjectForAlternativeContactPre}}{{else}}{{lang.mentionContent.genericEmailSubjectPre}}{{/if}} {{case.creditor.name}} [{{lang.mentionContent.journalNumber}} {{case.id}}-{{contact.id}}]`,
    },
    {
        mention: TemplateMention.JOURNAL_NUMBER,
        value: `{{case.id}}-{{contact.id}}`,
    },
    {
        mention: TemplateMention.CONTACT_ADDRESS_INLINE,
        value: `{{contact.address.address}}, {{contact.address.zipcode}} {{contact.address.city}}`,
    },
    {
        mention: TemplateMention.CONTACT_ADDRESS_FORMATTED,
        value: `{{contact.address.address}},
    <br />
    {{contact.address.zipcode}} {{contact.address.city}}`,
    },
    {
        mention: TemplateMention.DEBTOR_ADDRESS_INLINE,
        value: `{{debtor.address.address}}, {{debtor.address.zipcode}} {{debtor.address.city}}`,
    },
    {
        mention: TemplateMention.DEBTOR_ADDRESS_FORMATTED,
        value: `{{debtor.address.address}},
    <br />
    {{debtor.address.zipcode}} {{debtor.address.city}}`,
    },
    {
        mention: TemplateMention.SIGN_FIELDS,
        value: `<div style="display: inline-block; margin-right: 15px;">
  <p>
    <br />
    <br />
    _______________________<br />
    <small>{{#if case.isCompany}}CVR{{else}}CPR{{/if}}.nummer</small>
  </p>
</div>
<div style="display: inline-block; margin-right: 15px;">
  <p>
    <br />
    <br />
    _______________________<br />
    <small>{{lang.mentionContent.email}}</small>
  </p>
</div>
<div style="display: inline-block; margin-right: 15px;">
  <p>
    <br />
    <br />
    _______________________<br />
    <small>{{lang.mentionContent.phone}}</small>
  </p>
</div>
<br />
<br />
<div style="display: inline-block; margin-right: 15px;">
  <p>
    {{lang.mentionContent.date}}
    <br />
    <br />
    _______________________<br />
    <small>{{lang.mentionContent.signature}}</small>
  </p>
</div>`,
    },
];
var TemplateTag;
(function (TemplateTag) {
    TemplateTag["BPKWarning"] = "BPK_WARNING";
    TemplateTag["RKIWarning"] = "RKI_WARNING";
})(TemplateTag || (exports.TemplateTag = TemplateTag = {}));
//# sourceMappingURL=index.js.map